import React from 'react'
import Store from '../../store/store'
import Assignment from './Steps/Assignment'
import Download from './Steps/Download'
import i18 from '../../i18'
import api from '../../source/api'
import {Link} from 'react-router-dom'
import BaseComponent from '../base'
import CustomerRules from './CustomerRules'
import Upload from "./Steps/Upload";
import HeaderSteps from "./headersteps";
import NotificationSystem from "react-notification-system";
import Modal from "react-modal";
import RuleUpdateModal from "./Rules/RuleUpdateModal";

Modal.setAppElement('#root');

class Customer extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            company: null,
            config: null,
            currentStep: 1,

            onlineszamlaToken: false,
            showRulesPage: false,
            editRule: null,

            invoices: [],
            customerRules: [],
            vatCollectorCodes: [],
        }
        this.store = Store
    }

    notifySuccess = (message) => {
        this.refs.notificationSystem.addNotification({
            message: message,
            level: 'success',
            position: 'tc',
            autoDismiss: 10
        })
    };

    notifyError = (message) => {
        this.refs.notificationSystem.addNotification({
            message: message,
            level: 'error',
            position: 'tc',
            autoDismiss: 10
        })
    };

    componentDidMount = () => {
        window.scrollTo(0, 0)

        api.get('customer/' + this.props.location.match.params.id + '/init')
            .then((response) => {
                this.setState({
                    company: response.data.company,
                    config: response.data.config,
                    vatCollectorCodes: response.data.vatCollectorCodes,
                    customerRules: response.data.customerRules,
                    onlineszamlaToken: response.data.onlineszamlaToken
                })
            })
    }

    setStep = (step) => {
        this.setState({currentStep: step});
    }

    nextStep = () => {
        this.setStep(this.state.currentStep + 1);
    }

    toggleRulesPage = () => {
        this.setState({showRulesPage: !this.state.showRulesPage})
    }

    updateRules = (customerRules) => {
        this.updateInvoices(this.state.invoices, customerRules)
    }
    updateInvoices = (invoices, customerRules) => {
        let self = this;
        let addRuleCount = 0;
        let removeRuleCount = 0;

        invoices.map(function (invoice) {
            invoice.items.map(function (invoiceItem) {
                let selectedRule = self.invoiceItemFindRule(invoice, invoiceItem, customerRules);

                if (selectedRule) {
                    // talált a tételhez szabályt

                    if (invoiceItem.rule_id !== selectedRule.id) {
                        // eltérő szabály, tehát beállítja, és számolja
                        invoiceItem.rule_id = selectedRule.id;
                        addRuleCount++;
                    }
                } else if (invoiceItem.rule_id) {
                    // meglévő szabályt törli
                    invoiceItem.rule_id = null;
                    removeRuleCount++;
                }
            });
        });

        if (addRuleCount > 0) {
            this.notifySuccess(addRuleCount + ' darab sor sikeresen kontírozva.');
        }

        this.setState({
            invoices: invoices,
            customerRules: customerRules,
        })
    };

    invoiceItemFindRule = (invoice, invoiceItem, customerRules) => {
        for (let ruleIndex in customerRules) {
            if (this.invoiceCheckRule(invoice, invoiceItem, customerRules[ruleIndex])) {
                return customerRules[ruleIndex];
            }
        }
        return null;
    }

    invoiceCheckRule = (invoice, invoiceItem, rule) => {
        return (rule.item_name === null || invoiceItem.name.toLowerCase().indexOf(rule.item_name.toLowerCase()) !== -1)
            && (rule.invoice_number === null || rule.invoice_number === '' || invoice.invoiceNumber.toLowerCase().indexOf(rule.invoice_number.toLowerCase()) !== -1)
            && rule.company_type === invoice.company_type
            && parseInt(rule.vat, 0) === parseInt(invoiceItem.vat, 0)
            && (rule.position_number === null || rule.position_number === '' || invoice.positionNumber.toLowerCase().indexOf(rule.position_number.toLowerCase()) !== -1)
            && (rule.position_number_country === null || rule.position_number_country === '' || invoice.positionNumberCountry.toLowerCase().indexOf(rule.position_number_country.toLowerCase()) !== -1);
    }

    updateConfig = (config) => {
        this.setState({config: config});
    }

    editRule = (rule) => {
        this.setState({editRule: rule});
    }

    render() {
        if (!this.state.company) {
            return <section id='customer-upload'>
                <NotificationSystem ref='notificationSystem'/>
            </section>;
        }

        return (
            <section id='customer-upload'>
                {this.state.showRulesPage
                    ? <CustomerRules
                        config={this.state.config}
                        customerRules={this.state.customerRules}
                        vatCollectorCodes={this.state.vatCollectorCodes}

                        toggleRulesPage={() => this.toggleRulesPage()}
                        updateRules={(customerRules) => this.updateRules(customerRules)}
                        editRule={(rule) => this.editRule(rule)}
                        notifySuccess={(msg) => this.notifySuccess(msg)}
                        notifyError={(msg) => this.notifyError(msg)}
                    />
                    : <div>
                        <HeaderSteps
                            currentStep={this.state.currentStep}
                            setStep={(step) => this.setStep(step)}
                        />
                        <div className='header'>
                            <div className='container'>
                                <h1 className='margin-bottom-50'>{i18.CUSTOMER._title}</h1>
                                <p>{i18.CUSTOMER._description}</p>
                                <div className="row" style={{marginBottom: "50px"}}>
                                    <div className="col-md-12">
                                        <div className="pull-left">
                                            <h4 className='text-left'>Kiválasztott cég: {this.state.company.name} (<Link to='/' className='link-color'>cég csere</Link>)</h4>
                                        </div>
                                        <div className="pull-right">
                                            <Link className={this.state.onlineszamlaToken ? 'table-green-btn' : 'table-gray-btn'} to={`/company/onlineszamla/${this.state.company.id}`}>Onlineszámla API</Link>
                                            &nbsp;
                                            <a onClick={() => this.toggleRulesPage()} className="table-green-btn">Szabályok</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="upload-body">
                            {this.state.currentStep === 1
                                ? <div className='container'>
                                    <div className='row'>
                                        <div className='col-md-10 offset-md-1'>
                                            <Upload
                                            config={this.state.config}
                                            onlineszamlaToken={this.state.onlineszamlaToken}
                                            customerRules={this.state.customerRules}

                                            nextStep={() => this.nextStep()}
                                            updateInvoices={(invoices, customerRules) => this.updateInvoices(invoices, customerRules)}
                                            updateConfig={(config) => this.updateConfig(config)}
                                            notifySuccess={(msg) => this.notifySuccess(msg)}
                                            notifyError={(msg) => this.notifyError(msg)}
                                        />
                                        </div>
                                    </div>
                                </div>
                                : null
                            }
                            {this.state.currentStep === 2
                                ? <Assignment
                                    config={this.state.config}
                                    invoices={this.state.invoices}
                                    vatCollectorCodes={this.state.vatCollectorCodes}
                                    customerRules={this.state.customerRules}

                                    setInvoices={() => this.setInvoices()}
                                    nextStep={() => this.nextStep()}
                                    updateRules={(customerRules) => this.updateRules(customerRules)}
                                    notifySuccess={(msg) => this.notifySuccess(msg)}
                                    notifyError={(msg) => this.notifyError(msg)}
                                />
                                : null
                            }
                            {this.state.currentStep === 3
                                ? <Download
                                    config={this.state.config}
                                    invoices={this.state.invoices}
                                    notifySuccess={(msg) => this.notifySuccess(msg)}
                                    notifyError={(msg) => this.notifyError(msg)}
                                />
                                : null
                            }
                        </div>
                    </div>
                }

                {this.state.editRule
                    ? <RuleUpdateModal
                        config={this.state.config}
                        rule={this.state.editRule}
                        vatCollectorCodes={this.state.vatCollectorCodes}

                        editRule={(rule) => this.editRule(rule)}
                        updateRules={(customerRules) => this.updateRules(customerRules)}
                        notifySuccess={(msg) => this.notifySuccess(msg)}
                        notifyError={(msg) => this.notifyError(msg)}
                    />
                    : null
                }


                <NotificationSystem ref='notificationSystem'/>
            </section>
        )
    }
}

export default Customer


// WEBPACK FOOTER //
// ./src/components/customer/customer.js